module.exports = __webpack_public_path__ + "link-d2a372bb0044de89e9db9f4b98c9c9da.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/link.svg
// module id = 42
// module chunks = 0